import React from 'react';
import { number } from 'prop-types';
import Tooltip from 'components/Map/MapComponents/Tooltip';
import TooltipItem from 'components/Map/MapComponents/TooltipItem';
import formatFloat from 'helpers/formatFloat';
import formatMinutesSeconds from 'helpers/formatMinutesSeconds';

import styles from './segment-tooltip.scss';

export default function PathSuggestionTooltip({ distance, expectedTravelTime }) {
  /*
   * @TODO Put this in a helper function or use a library to do this kind of stuff.
   * Even better, we could do this conversion in GraphQL
   */
  const distanceInMiles = distance * 0.000621371;
  return (
    <Tooltip sticky offset={[5, -10]} className={styles.main}>
      <div className={styles.distance}>
        <TooltipItem label="distance">
          {`${formatFloat(distanceInMiles)} miles`}
        </TooltipItem>
      </div>
      <TooltipItem label="travel time">
        {formatMinutesSeconds(expectedTravelTime)}
      </TooltipItem>
    </Tooltip>
  );
}

PathSuggestionTooltip.propTypes = {
  distance: number.isRequired,
  expectedTravelTime: number.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/Map/CreateSegment/PathSuggestionTooltip/index.js